// THIS IS AN AUTO GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export const VERSION = '1.19.1';
export const VERSION_NUMBER = 119001000;
